import * as React from "react";

// Styles
import "./TopicIntro.scss";

interface TopicIntro {
  title: string;
  description: string;
  imageUrl: string;
}

const TopicIntro: React.FC<TopicIntro> = (props: TopicIntro) => {
  const { title, description, imageUrl } = props;

  return (
    <div className="mb-2 text-center topic-intro">
      <div className="topic-intro__image relative">
        <img
          src={imageUrl}
          alt={title}
          className="absolute h-full w-full object-cover object-center"
        />
        <div className="topic-intro__image__gradient" />
        <div className="topic-intro__title">
          <p className="topic-intro__title__tag text-white text-s uppercase font-bold bg-dw-bright-blue inline-block lg:text-l">
            Topic
          </p>
          <h1 className="text-l sm:text-2xl md:text-3xl lg:text-5xl xl:text-6xl text-white font-semibold mt-1 md:mt-2 mb-2 md:mb-3">
            {title}
          </h1>
        </div>
      </div>
      <div className="mx-auto container">
        <div className="mt-3 text-center w-11/12 xxl:w-full mx-auto">
          <p className="text-dw-grey-13 font-bold lg:text-18">{description}</p>
        </div>
      </div>
    </div>
  );
};

export default TopicIntro;
